import React from "react";
import PropTypes from "prop-types";
import CardRibbon from "../customBreachBits/accents/CardRibbon";
import IntlMessages from "../../util/IntlMessages";

const RiskRibbon = ({styleName, ratingBy5, titleOverride, tipTextOverride}) => {

    let titleToUse = ""
    let tipTextToUse = "";

    switch (ratingBy5) {
        case 0:
            titleToUse = <>Adds <IntlMessages id="risk.rating.0.verbTitle"/> Risk</>
            tipTextToUse = <IntlMessages id="risk.rating.0.description.long"/>
            break;
        case 1:
            titleToUse = <>Adds <IntlMessages id="risk.rating.1.verbTitle"/> Risk</>
            tipTextToUse = <IntlMessages id="risk.rating.1.description.long"/>
            break;
        case 2:
            titleToUse = <>Adds <IntlMessages id="risk.rating.2.verbTitle"/> Risk</>
            tipTextToUse = <IntlMessages id="risk.rating.2.description.long"/>
            break;
        case 3:
            titleToUse = <>Adds <IntlMessages id="risk.rating.3.verbTitle"/> Risk</>
            tipTextToUse = <IntlMessages id="risk.rating.3.description.long"/>
            break;
        case 4:
            titleToUse = <>Adds <IntlMessages id="risk.rating.4.verbTitle"/> Risk</>
            tipTextToUse = <IntlMessages id="risk.rating.4.description.long"/>
            break;
        default:
            titleToUse = null
            tipTextToUse = null
            break;
    }

    if (titleOverride) {
        titleToUse = titleOverride
    }
    if (tipTextOverride) {
        tipTextToUse = tipTextOverride
    }

    return (
        <CardRibbon
            title={titleToUse}
            tipText={tipTextToUse}
            styleName={styleName}
        />
    )
};

export default RiskRibbon;

RiskRibbon.propTypes = {
    ratingBy5: PropTypes.oneOfType([
        PropTypes.number,
    ]),
    titleOverride: PropTypes.string,
    tipTextOverride: PropTypes.string,
};
